import request from '@/utils/request'

// 消息中心  获取消息详情，同时设为已读
export function getMessageDetail(data) {
  return request({
    url: `/shop/message/getMessageDetail?id=${data}`,
    method: 'GET'
  })
}

// 消息中心   获取所有消息列表
export function getMessageList(data1, data2, data3) {
  return request({
    url: `/shop/message/getMessageList?limit=${data1}&page=${data2}&readStatus=${data3}`,
    method: 'GET'
  })
}

//全部已读按钮
export function readAll() {
  return request({
    url: `/shop/message/readAll`,
    method: 'POST'
  })
}

//获取未读消息数量
export function getUnReadMessageCount() {
  return request({
    url: `/shop/message/getUnReadMessageCount`,
    method: 'GET'
  })
}

//获取历史全部未读消息概要列表，小按钮悬浮用的
export function getUnReadMessageOverview() {
  return request({
    url: `/shop/message/getUnReadMessageOverview`,
    method: 'GET'
  })
}

// 获取一个月内全部的未投递消息，用作提醒功能
export function getUnDeliveredMessage () {
  return request ({
    url:`/shop/message/getUnDeliveredMessage`,
    method:'GET'
  })
}
//查询预约任务
export function getTaskList(data) {
  return request({
    url: `/shop/schedule/getTaskList`,
    method: 'GET',
    params: data
  })
}

//创建预约任务
export function create(data) {
  return request({
    url: `/shop/schedule/create`,
    method: 'POST',
    data
  })
}

//编辑预约任务
export function update(data) {
  return request({
    url: `/shop/schedule/update`,
    method: 'POST',
    data
  })
}

//删除预约任务
export function deleteTask(data) {
  return request({
    url: `/shop/schedule/delete`,
    method: 'POST',
    data
  })
}

//完成预约任务
export function completeTask(data) {
  return request({
    url: `/shop/schedule/completeTask`,
    method: 'POST',
    data
  })
}

//切换任务状态
export function switchTaskStatus(data) {
  return request({
    url: `/shop/schedule/switchTaskStatus`,
    method: 'POST',
    data
  })
}